import { Col } from '../../col';
import { Row } from '../../row';
import { Space } from '../../space';
import Skeleton from '../Skeleton';
import styles from './entity-skeleton.module.css';

const EntitySkeleton = () => (
  <Space orientation="vertical" size="small">
    <Row align="middle" className={styles.row} gutter={['xs', 'xs']}>
      <Col>
        <Skeleton.Avatar active size="default" />
      </Col>
      <Col className={styles.paragraph}>
        <Skeleton active paragraph={{ rows: 2 }} title={false} />
      </Col>
    </Row>
  </Space>
);

export default EntitySkeleton;
